<template>
  <div id="nav-container" class="wrap">
    <nav id="status" style="" class="wrap">
  
      <a href="javascript: void 0" @click="$emit('changeSection','start')" id="goto-start" class="actif">
        <i class="icon-valid"></i>
        NATURE
      </a>
      <a href="javascript: void 0" id="goto-intervention" @click="$emit('changeSection','intervention')">
        <i class="icon-valid"></i>
        INTERVENTION
      </a>
      <a href="javascript: void 0" id="goto-finish" @click="$emit('changeSection','finish')">
        <i class="icon-valid"></i>
        SIGNATURE
      </a>
  
    </nav>
  </div>
</template>

<script>
export default {
  methods: {
  
  }
}
</script>

<style>
#nav-container {
  background-color: #eee;
}
nav#status {
  height: 80px;
  max-width: 425px;
}
nav#status a {
  display: block;
  position: relative;
  float: left;
  width: 33.3%;
  height: 75px;
  padding-top: 58px;
  text-align: center;
  color: #333333;
  font-size: 1.2rem;
  font-weight: 700;
}
nav#status a:last-child.actif i:after {
  display: none;
}
nav#status a:before {
  content: '';
  display: block;
  position: absolute;
  top: 8px;
  height: 46px;
  width: 46px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  background-color: #cccccc;
  border-radius: 50%;
}
nav#status a:not(:last-child):after {
  content: '';
  display: block;
  position: absolute;
  top: 28px;
  height: 5px;
  width: 100%;
  background-color: #cccccc;
  left: 50%;
}
nav#status a i {
  position: absolute;
  display: block;
  top: 8px;
  height: 46px;
  width: 46px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  z-index: 80;
}
nav#status a i:before {
  content: '';
  position: absolute;
}
nav#status a.actif i {
  background-color: #86bc24;
}
nav#status a.actif i:before {
  content: '\e92e';
  top: 5px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  color: #435e12;
  font-size: 3.5rem;
}
nav#status a.actif i:after {
  content: '';
  display: block;
  position: absolute;
  top: 20px;
  height: 5px;
  width: 200%;
  background-color: #86bc24;
  z-index: 75;
  left: 100%;
}
nav#status a.actif + a:not(.actif) i {
  overflow: hidden;
  background-color: #86bc24;
}
nav#status a.actif + a:not(.actif) i:before {
  right: 0;
  top: 0;
  display: block;
  height: 46px;
  width: 24px;
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// Nav.vue?1e1954aa